import useTestId from '@ori/testid-generator';
import { useEffect, useCallback, useState, useRef, useMemo } from 'react';
import { LAZY_IMAGE } from '../../common';
import { ImagePlaceholder } from '../ImagePlaceholder';
import { Img } from './styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const LazyImage = ({
  alt,
  imageRef,
  placeholderHeight,
  placeholderWidth,
  placeholderAbsolute,
  src,
  srcSet,
  testId,
  onImageLoad,
  onLoad,
  ...restProps
}) => {
  const localRef = useRef(null);
  const ref = useMemo(() => imageRef ?? localRef, [imageRef]);
  const [isPlaceholderVisible, setIsPlaceholderVisible] = useState(true);
  const {
    getTestId
  } = useTestId();
  const handleLoad = useCallback(e => {
    setIsPlaceholderVisible(false);
    onLoad?.(e);
  }, [onLoad]);
  const handleLoadEvent = useCallback(() => {
    onImageLoad?.();
  }, [onImageLoad]);
  useEffect(() => {
    const lazyImageElement = ref.current;
    // istanbul ignore next -- Not reachable in tests
    if ((Boolean(src) || Boolean(srcSet)) && isPlaceholderVisible && lazyImageElement?.complete) {
      setIsPlaceholderVisible(false);
    }
    lazyImageElement?.addEventListener('load', handleLoadEvent);
    return () => {
      lazyImageElement?.removeEventListener('load', handleLoadEvent);
    };
  }, [handleLoadEvent, isPlaceholderVisible, ref, src, srcSet]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isPlaceholderVisible ? /*#__PURE__*/_jsx(ImagePlaceholder, {
      isLoadingPlaceholder: true,
      absolute: placeholderAbsolute,
      isSquare: placeholderHeight === undefined && placeholderWidth === undefined,
      height: placeholderHeight,
      width: placeholderWidth
    }) : null, /*#__PURE__*/_jsx(Img, {
      ref: ref,
      alt: alt ?? src,
      src: src,
      srcSet: srcSet,
      "data-testid": testId ?? getTestId(LAZY_IMAGE),
      role: "presentation",
      isPlaceholderVisible: isPlaceholderVisible,
      onLoad: handleLoad,
      ...restProps
    })]
  });
};
//# sourceMappingURL=LazyImage.js.map